export const newsArticles = [
  {
    id: "chang-gongzhu-chaotang-mitan",
    title: "《长公主在上》朝堂大戏幕后：127位群演与一场拍了三天的对峙",
    category: "幕后制作",
    date: "2025-08-28",
    author: "本社编辑部",
    heat: 42100,
    cover:
      "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20set%20of%20an%20ancient%20chinese%20palace%20hall%20with%20costumed%20extras%20and%20camera%20crew%2C%20warm%20candlelight%2C%20crimson%20columns%2C%20documentary%20photography%20style%2C%20cinematic%20lighting&width=900&height=560&seq=duanju-news-01&orientation=landscape",
    excerpt:
      "一场朝堂对峙拍了整整三天，从站位、视线到烛台的摆放位置都被反复校准。我们联系到该剧的副导演，聊了聊这场戏到底难在哪。",
    paragraphs: [
      "在《长公主在上》里最被观众反复回看的，是第九集那场朝堂对峙。镜头从殿门一路推进到丹陛之前，二十余句台词在沉默与交锋之间来回切换。很少有人知道，这场戏的拍摄前前后后用了三天。",
      "副导演在采访中提到，最大的难点不是台词，而是「视线」。一百二十七位群演分列两侧，谁在什么时候看主角、谁必须把目光压低，都有明确的分区表。摄影机横扫而过时，一旦有人提前抬头，整条就作废。",
      "为了配合烛光的方向，道具组在殿内布置了六十四盏可调角度的烛台，每换一次机位就要重新校准亮度。制片主任笑着说，那三天的蜡烛消耗量，抵得上其他场景一个月的用量。",
      "这场戏最终在成片里保留了将近四分钟，没有使用任何补拍镜头。主创团队把这种拍法称作「一次成型的赌注」，因为它对演员状态、灯光和群演的配合要求都太高了。",
    ],
  },
  {
    id: "guilai-shaonianlang-qujing",
    title: "《归来仍是少年郎》取景地探访：那条被保留的老街现在怎么样了",
    category: "拍摄花絮",
    date: "2025-08-19",
    author: "外勤小组",
    heat: 31600,
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20southern%20chinese%20old%20street%20with%20small%20shops%20and%20red%20lanterns%2C%20warm%20late%20afternoon%20sunlight%2C%20nostalgic%20documentary%20photography%2C%20soft%20film%20grain%2C%20gentle%20atmosphere&width=900&height=560&seq=duanju-news-02&orientation=landscape",
    excerpt:
      "剧组拍完离开后，那条老街的店铺招牌被完整保留了下来。我们回到现场，看看当地居民怎么看待这部把他们生活拍进去的短剧。",
    paragraphs: [
      "《归来仍是少年郎》里反复出现的那条老街，并不是搭建的布景，而是南方一座真实街区。剧组在开拍前两个月就进组沟通，最后只改动了招牌的做旧程度，其余维持原样。",
      "便利店老板在镜头前有些不好意思，他说自己起初并不看好，「拍个几天就走了嘛」。结果剧组待了将近四周，还帮街口那盏坏了很久的路灯修好了。",
      "美术指导解释，他们刻意没有「美化」这条街。地上的水渍、卷帘门掉漆的边角、电线杆上的小广告，全都保留在画面里，因为那些细节本身就是故事的一部分。",
      "剧集播出后，陆续有人来打卡。当地居民对此态度复杂，一方面热闹了，一方面又担心街道被过度打扰。剧组留下的建议是：来可以，但请像住在这里的人一样安静。",
    ],
  },
  {
    id: "moban-ditie-jieju-jiedu",
    title: "《末班地铁的陌生人》结局解析：那七处藏在线索里的细节",
    category: "口碑解读",
    date: "2025-07-30",
    author: "剧评组",
    heat: 52800,
    cover:
      "https://readdy.ai/api/search-image?query=empty%20modern%20subway%20platform%20at%20night%20with%20warm%20amber%20lights%20and%20long%20shadows%2C%20mysterious%20moody%20atmosphere%2C%20cinematic%20film%20noir%20photography%2C%20clean%20composition&width=900&height=560&seq=duanju-news-03&orientation=landscape",
    excerpt:
      "很多观众看完《末班地铁的陌生人》第一反应是「没懂」，也有人整理出了两百多页推理。我们把主创埋下的关键线索重新梳理了一遍。",
    paragraphs: [
      "《末班地铁的陌生人》在收官后评分稳定在 8.8，讨论度却远高于同期作品。原因很简单：它把所有答案都藏在了画面里，而不是台词里。",
      "第一处线索出现在第二集。列车员皮鞋的后跟有一道不规则的磨损，这个细节在最后一集被重新给到特写，暗示人物已经走过很长的一段路。",
      "第二处是报纸。男人手里的旧报纸日期始终停在同一天，但标题却在每一集里微微变化。观众需要暂停才能发现，这也是这部剧被称作「暂停键神剧」的原因。",
      "主创在采访中表示，他们并不打算给出唯一答案。「我们想做的不是解谜，而是让观众在走出地铁的那一刻，怀疑一下自己刚才坐过的那一站。」这句话本身，或许就是最好的解读。",
    ],
  },
  {
    id: "duanju-hangye-houqi-mitan",
    title: "短剧后期到底在忙什么？我们跟组看了一整晚的剪辑",
    category: "幕后制作",
    date: "2025-07-12",
    author: "本社编辑部",
    heat: 28400,
    cover:
      "https://readdy.ai/api/search-image?query=film%20editing%20studio%20at%20night%20with%20multiple%20monitors%20showing%20video%20timelines%2C%20warm%20desk%20lamps%20against%20dark%20room%2C%20documentary%20photography%2C%20cinematic%20mood%2C%20tech%20workspace&width=900&height=560&seq=duanju-news-04&orientation=landscape",
    excerpt:
      "一部短剧从杀青到上线，后期往往只留出很短的时间。剪辑师如何在有限的窗口里兼顾节奏、情绪和平台适配？",
    paragraphs: [
      "短剧的后期节奏和传统剧集很不一样。一部八十集的竖屏短剧，留给剪辑的时间常常只有三到四周，而每一个「卡点」都直接关系到观众会不会划走。",
      "剪辑师最常做的一件事是「删开头」。观众进入一部短剧的耐心通常只有几秒，因此剪辑台前贴着一张手写便签：前三秒必须有事发生。",
      "配乐和音效同样关键。同一场戏，换掉背景音乐的情绪走向，观众对人物的判断可能完全相反。有经验的剪辑会保留几版不同情绪的配乐，交给导演做最后取舍。",
      "最容易被忽略的是画幅适配。同一部作品要同时投放到竖屏、横屏和方屏渠道，字幕安全区、人物构图都要分别检查，这也是后期时间被压缩的主要压力来源。",
    ],
  },
  {
    id: "chongsheng-jiaqianjin-koubei",
    title: "《重生之假千金上门》口碑攀升：为什么爽感之外还有人在讨论「体面」",
    category: "口碑解读",
    date: "2025-06-25",
    author: "剧评组",
    heat: 36900,
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20warm%20mansion%20interior%20with%20marble%20staircase%20and%20golden%20afternoon%20light%20through%20tall%20windows%2C%20luxurious%20but%20restrained%20style%2C%20editorial%20interior%20photography%2C%20cinematic%20mood&width=900&height=560&seq=duanju-news-05&orientation=landscape",
    excerpt:
      "一部主打逆袭的短剧，评论区却意外地聊起了「体面」。我们从观众的真实讨论里，看到了这类作品正在发生的变化。",
    paragraphs: [
      "《重生之假千金上门》上线后迅速冲上热播榜，评分稳定在 8.6。它当然有爽剧该有的节奏，但真正让它被反复讨论的，是它对「体面」的处理。",
      "剧中的苏家从不在人前失态。所有冲突都被包裹在得体的措辞和恰到好处的沉默里，这反而让观众感到更强烈的压迫。有观众评论说，最可怕的不是被骂，而是被礼貌地排除在外。",
      "这种克制也体现在运镜上。很多关键情绪没有给特写，而是留在画面边缘——一个转身、一只停在门把上的手。这种「不把话说满」的表达，让短剧的质感上升了一个层级。",
      "当然，也有观众认为中段节奏偏慢。但从整体口碑走向看，愿意为人物留白的作品，正在获得比以往更长的讨论周期。",
    ],
  },
  {
    id: "minguo-xiaochuniang-meishi",
    title: "《民国小厨娘》里的四十六道菜，是怎么被拍出来的",
    category: "拍摄花絮",
    date: "2025-06-08",
    author: "外勤小组",
    heat: 25300,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20vintage%20chinese%20kitchen%20with%20steaming%20bamboo%20baskets%20and%20fresh%20ingredients%2C%20golden%20lantern%20light%2C%20nostalgic%20republic%20era%20style%2C%20appetizing%20food%20photography%2C%20soft%20shadows&width=900&height=560&seq=duanju-news-06&orientation=landscape",
    excerpt:
      "为了拍出真正有烟火气的厨房，剧组请了本地老师傅全程跟组。四十六道菜里，有一道连拍了九条才过关。",
    paragraphs: [
      "美食是《民国小厨娘》的核心。为了不靠道具糊弄，剧组请了一位做本帮菜的老师傅全程跟组，所有出现在镜头里的菜都是现做现拍。",
      "最难拍的是葱油拌面。面条出锅后只有很短的时间保持最佳状态，而特写、全景、演员进食的镜头又必须分开拍摄。这一个镜头，前后做了九条。",
      "灯光组也下了功夫。厨房的光源全部模拟煤油灯和灶火，为此定制了暖色柔光板和可调节的炉膛反光板，让食物看起来油亮却不反光。",
      "老师傅在片场最常说的一句话是「凉了就不好吃了」。也因为这句话，剧组养成了一个习惯：每条拍完，工作人员会先把菜分掉，不留隔夜。",
    ],
  },
];

export const newsCategories = [
  { key: "all", label: "全部资讯" },
  { key: "拍摄花絮", label: "拍摄花絮" },
  { key: "幕后制作", label: "幕后制作" },
  { key: "口碑解读", label: "口碑解读" },
];